import { ContentService, DcrKeyPipe } from '@blk/cwp-ng-framework';
import { EsgConstants } from '@ddt-web/config';
import { CellData } from '@ddt-web/data-service';
import { NumberUtil } from '@ddt-web/generic-utils';


export class EsgScoreImpactUtil {

	public static getCarbonImpactScore(cell: CellData, metric: string, equivalencyMap: Object, enableRoundOff: boolean = false): string {
		let equivalencyScore = '-';
		if (cell && equivalencyMap) {
			const carbonRating = Number(cell.rawValue?.toString());
			if (isNaN(carbonRating)) {
				equivalencyScore = cell.formattedValue;
			} else {
				const carbonEquivalency = Number(equivalencyMap[metric]);
				const impactScore = carbonEquivalency * carbonRating;
				const decimalPlaces = enableRoundOff ? 0 : 2;
				equivalencyScore = NumberUtil.formatWithPrecisionRounding(impactScore, 2, decimalPlaces);
			}

		}
		return equivalencyScore;
	}

	public static getMetricIcon(equivalency: string, contentService: ContentService): string {
		const iconDcrKey = new DcrKeyPipe().transform(`ESG_METRIC_${equivalency}_ICON`);
		return contentService.get(iconDcrKey, EsgConstants.ESG_METRIC_ICONS[equivalency]);
	}

	public static getCarbonEmissionDifference(carbonScore, carbonScoreBenchmark): string {
		let equivalencyScore: string = '-';
		if (carbonScore && carbonScoreBenchmark) {
			const carbonRating = Number(carbonScore.rawValue?.toString());
			const carbonRatingBenchmark = Number(carbonScoreBenchmark.rawValue?.toString());
			if (!isNaN(carbonRating) && !isNaN(carbonRatingBenchmark)) {
				const ratio = (carbonRatingBenchmark - carbonRating) / carbonRatingBenchmark;
				if (Number.isFinite(ratio)) {
					equivalencyScore = (ratio).toFixed(1);
				}
			}
		}
		return equivalencyScore;
	}
}
